import React from 'react';
import {PreviewFooter, PreviewButton} from 'react-weui';
import {Link} from 'react-router'
import {connect} from 'react-redux'
import '../../styles/classroom/ClassroomShareRank.css';
import crownImg1 from '../../images/crown1.png'
import crownImg2 from '../../images/crown2.png'
import crownImg3 from '../../images/crown3.png'

const crowns = [crownImg1, crownImg2, crownImg3]

class ClassroomShareRank extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            hidden: false
        }
    }

    componentWillMount() {
        const {lecture} = this.props
        const hide = sessionStorage.getItem('hideShareRank/' + lecture.id)
        if (hide) {
            this.setState({hidden: true})
        }
    }

    onGetMyShareCard() {
        let {lecture, account} = this.props
        if (!(account && account.id)) {
            account.id = ''
        }
        window.location = `/lecture/${lecture.id}/sharecard?account_id=${account.id}`;
    }

    hide() {
        const {lecture} = this.props
        sessionStorage.setItem('hideShareRank/' + lecture.id, '1')
        this.setState({hidden: true})
    }
    
    render() {
        const {share_rank, channel, lecture} = this.props
        const isSpecial = (channel && channel.id !== 58123 && channel.id !== 62884) || !channel;

        if (this.state.hidden) {
            return null;
        }
        return (<div className="message-box share-rank">
            <div className="title">
                影响力排行榜
                <span className="close" onClick={this.hide.bind(this)}>
                    <i className="iconfont icon-cuowu"></i>
                </span>
            </div>
            {isSpecial &&
            <Link to={`/lecture/${lecture.id}/sharerank`} >
                <div className="content">
                    {share_rank.length === 0 ?
                        <p style={{color: '#888'}}>邀请好友听课，强势上榜</p>
                        :
                        <ul className="weui-flex">
                            {
                                share_rank.slice(0, 5).map((r, index) => {
                                    return <li className="weui-flex__item user-item" key={r.account.id}>
                                        <div className="position-relative inline-block">
                                            <div className="avatar">
                                                <img className="circle" alt="" src={r.account.small_avatar_url}/>
                                            </div>
                                            <div className="crown">
                                                { index < 3 && <img src={crowns[index]} alt="" /> }
                                            </div>
                                        </div>
                                        <p className="text-minor text-ellipsis" style={{fontSize: "10px"}}>
                                            {r.account.nickname}
                                        </p>
                                        <div className='count-wrap'>
                                            <p className={`invite-num text-ellipsis invite-num-${index}`}>
                                                {r.count}
                                            </p>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                    }
                </div>
            </Link>
            }
            <button className='my-card-btn' onClick={this.onGetMyShareCard.bind(this)} style={{marginTop: isSpecial ? "0" : "15px"}}>
            <img src="https://static-1253442168.image.myqcloud.com/picture/6163344_9127655f16566c18fbb6c0a7248bfe5c.jpg" className="handIcon"/>
                邀请好友
            </button>
        </div>)
    }
}


export default connect((state) => ({
    share_rank: state.classroom.share_rank,
    lecture: state.classroom.lecture,
    channel: state.classroom.channel,
    account: state.account
}))(ClassroomShareRank)



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomShareRank.js